import { Typography, useTheme } from "@material-ui/core";
import React from "react";
import { useTranslate } from "react-admin";

interface EmptyStateProps {
  hasTerminal: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ hasTerminal }) => {
  const theme = useTheme();
  const translate = useTranslate();

  return (
    <div
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        textAlign: "center",
        color: theme.palette.secondary.main,
      }}
    >
      {!hasTerminal ? (
        <Typography variant="h5" color="inherit">
          {translate("osfc.storage_ui.empty_state.select_terminal")}
        </Typography>
      ) : (
        <div>
          <Typography variant="h5" color="inherit" gutterBottom>
            {translate("osfc.storage_ui.empty_state.no_config")}
          </Typography>
          <Typography variant="body1" color="inherit">
            {translate("osfc.storage_ui.empty_state.upload_hint")}
          </Typography>
        </div>
      )}
    </div>
  );
};
